import { render, staticRenderFns } from "./space-course.vue?vue&type=template&id=23400f58&scoped=true"
import script from "./space-course.vue?vue&type=script&lang=js"
export * from "./space-course.vue?vue&type=script&lang=js"
import style0 from "./space-course.vue?vue&type=style&index=0&id=23400f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23400f58",
  null
  
)

export default component.exports